var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60.44px",
    height: "81.025px",
    viewBox: "119.685 -19.263 60.44 81.025",
    enableBackground: "new 119.685 -19.263 60.44 81.025",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.7543,
    y1: 256.5595,
    x2: 49.4835,
    y2: 220.6824,
    gradientTransform: "matrix(1 0 0 -1 123.345 254.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88BEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2087,
    style: {
      stopColor: "#60A7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4426,
    style: {
      stopColor: "#3B91CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6601,
    style: {
      stopColor: "#2081C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8526,
    style: {
      stopColor: "#1077BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A74BA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M150.317-19.263c20.732,0.042,34.635,19.037,28.238,39.16 c-4.955,15.588-15.07,28.062-25.766,40.072c-2.371,2.663-4.492,2.185-6.532-0.288c-9.863-11.953-19.928-23.852-24.871-38.874 C114.61,0.209,128.849-19.306,150.317-19.263z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 149.904,
    cy: 10.586,
    r: 23.06
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4D4E4E",
    d: "M164.201,2.942h-8.874c0,0-17.584,20.176-17.895,20.533c-0.148,0.17-0.046,0.228,0.076,0.246h1.962 c0,0,13.655,0,18.098,0c0.383,0,0.491-0.038,0.613-0.451C158.236,23.084,164.201,2.942,164.201,2.942z M157,22.603h-1.294 l1.574-4.171h-1.466l-1.768,4.171h-1.501l1.955-4.194l-1.528,0.023l-2.146,4.171h-4.641l2.689-4.171h-1.65l-2.908,4.171h-1.328 l3.064-4.171h-1.736l-3.296,4.171h-1.339l15.977-19.305h7.891L157,22.603z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "157.758,5.669 156.97,6.96 158.136,6.96 158.848,5.669  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "158.863,3.775 158.197,4.866 159.259,4.866 159.861,3.775  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3892CF",
    d: "M155.774-0.958c-0.001,0-0.002,0-0.004,0c-0.093-0.075-0.188-0.147-0.287-0.214 c-0.024-0.015-0.047-0.035-0.071-0.046c-0.677-0.442-1.48-0.706-2.347-0.706c-0.008,0-0.015,0-0.023,0 c-1.01-1.927-2.989-3.141-5.205-3.141c-1.931,0-3.735,0.955-4.828,2.524c-1.266,0.006-2.465,0.6-3.245,1.583 c-0.015,0-0.03,0-0.045,0c-2.111,0-3.829,1.718-3.829,3.829c0,2.111,1.717,3.829,3.829,3.829h4.547h6.962h4.547 c2.111,0,3.829-1.718,3.829-3.829C159.603,0.76,157.885-0.958,155.774-0.958z M155.774,4.982h-3.125h-9.805h-3.125 c-1.164,0-2.111-0.947-2.111-2.111c0-1.164,0.947-2.111,2.111-2.111c0.098,0,0.206,0.009,0.332,0.029l0.575,0.091l0.298-0.5 c0.448-0.754,1.235-1.203,2.106-1.203c0.093,0,0.195,0.008,0.321,0.024l0.575,0.075l0.285-0.504 c0.739-1.307,2.129-2.119,3.627-2.119c1.725,0,3.246,1.038,3.877,2.644l0.253,0.644c0,0,0.12-0.055,0.764-0.104 c0.429-0.033,1.378,0.023,1.888,0.628l0.247,0.416l0.575-0.091c0.126-0.02,0.234-0.029,0.332-0.029 c1.164,0,2.111,0.947,2.111,2.111C157.885,4.035,156.938,4.982,155.774,4.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M155.774,4.982h-3.125h-9.805h-3.125c-1.164,0-2.111-0.947-2.111-2.111c0-1.164,0.947-2.111,2.111-2.111 c0.098,0,0.206,0.009,0.332,0.029l0.575,0.091l0.298-0.5c0.448-0.754,1.235-1.203,2.106-1.203c0.093,0,0.195,0.008,0.321,0.024 l0.575,0.075l0.285-0.504c0.739-1.307,2.129-2.119,3.627-2.119c1.725,0,3.246,1.038,3.877,2.644l0.253,0.644 c0,0,0.12-0.055,0.764-0.104c0.429-0.033,1.378,0.023,1.888,0.628l0.247,0.416l0.575-0.091c0.126-0.02,0.234-0.029,0.332-0.029 c1.164,0,2.111,0.947,2.111,2.111C157.885,4.035,156.938,4.982,155.774,4.982z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "152.632,14.073 152.026,15.081 152.022,15.083 150.987,16.77 152.739,16.77 154.229,14.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "154.825,10.493 153.626,12.436 155.12,12.426 156.182,10.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "156.485,7.718 155.487,9.392 156.795,9.392 157.721,7.714  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker2X);
export default __webpack_public_path__ + "static/media/marker-2x.8a64f9eac67567a82adbac1f795c4645.svg";
export { ForwardRef as ReactComponent };